export default class FontService {
  constructor(targetElement = document.head) {
    this.targetElement = targetElement;
    this.currentStyleElement = null;
  }

  updateFonts(fonts) {
    if (!document.fonts) {
      const styleElement = document.createElement('style');

      for (const font of fonts) {
        styleElement.innerHTML += this.generateFontFace(font);;
      }

      document.head.appendChild(styleElement);
  
      return;
    }

    for (const font of fonts) {
      const loadedFont = new FontFace(font.name, `url(${font.file.file_url})`);
      document.fonts.add(loadedFont);
    }

    return document.fonts.ready;
  }

  generateFontFace(font) {
    return `@font-face {
      font-family: '${font.name}';
      font-style: normal;
      src: url(${font.file.file_url});
    }\n`;
  }

  getCustomFontsByFontIds(fonts, { normalFontId, semiBoldFontId, boldFontId }) {
    let fontNormal = null;
    let fontSemiBold = null;
    let fontBold = null;

    for (const font of fonts) {
      switch (font.id) {
      case normalFontId:
        fontNormal = font;
        break;
      case semiBoldFontId:
        fontSemiBold = font;
        break;
      case boldFontId:
        fontBold = font;
        break;
      }
    }

    return {
      fontNormal,
      fontSemiBold,
      fontBold
    };
  }

  destroy() {
    if (this.currentStyleElement) {
      this.targetElement.removeChild(this.currentStyleElement);
    }
  }
}
